import { UNDevelopmentGoals } from "../../../../services/users";

export interface GoalsProps {
  name: UNDevelopmentGoals;
  url: string;
  imageUrl: string;
}

const goals: GoalsProps[] = [
  {
    name: UNDevelopmentGoals["Erradicação da Pobreza"],
    url: "https://brasil.un.org/pt-br/sdgs/1",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-1.svg",
  },
  {
    name: UNDevelopmentGoals["Fome Zero e Agricultura Sustentável"],
    url: "https://brasil.un.org/pt-br/sdgs/2",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-2.svg",
  },
  {
    name: UNDevelopmentGoals["Saúde e Bem-Estar"],
    url: "https://brasil.un.org/pt-br/sdgs/3",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-3.svg",
  },
  {
    name: UNDevelopmentGoals["Educação de Qualidade"],
    url: "https://brasil.un.org/pt-br/sdgs/4",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-4.svg",
  },
  {
    name: UNDevelopmentGoals["Igualdade de Gênero"],
    url: "https://brasil.un.org/pt-br/sdgs/5",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-5.svg",
  },
  {
    name: UNDevelopmentGoals["Água Potável e Saneamento"],
    url: "https://brasil.un.org/pt-br/sdgs/6",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-6.svg",
  },
  {
    name: UNDevelopmentGoals["Energia Limpa e Acessível"],
    url: "https://brasil.un.org/pt-br/sdgs/7",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-7.svg",
  },
  {
    name: UNDevelopmentGoals["Trabalho Decente e Crescimento Econômico"],
    url: "https://brasil.un.org/pt-br/sdgs/8",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-8.svg",
  },
  {
    name: UNDevelopmentGoals["Indústria, Inovação e Infraestrutura"],
    url: "https://brasil.un.org/pt-br/sdgs/9",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-9.svg",
  },
  {
    name: UNDevelopmentGoals["Redução das Desigualdades"],
    url: "https://brasil.un.org/pt-br/sdgs/10",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-10.svg",
  },
  {
    name: UNDevelopmentGoals["Cidades e Comunidades Sustentáveis"],
    url: "https://brasil.un.org/pt-br/sdgs/11",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-11.svg",
  },
  {
    name: UNDevelopmentGoals["Consumo e Produção Responsáveis"],
    url: "https://brasil.un.org/pt-br/sdgs/12",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-12.svg",
  },
  {
    name: UNDevelopmentGoals["Ação Contra a Mudança Global do Clima"],
    url: "https://brasil.un.org/pt-br/sdgs/13",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-13.svg",
  },
  {
    name: UNDevelopmentGoals["Vida na Água"],
    url: "https://brasil.un.org/pt-br/sdgs/14",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-14.svg",
  },
  {
    name: UNDevelopmentGoals["Vida Terrestre"],
    url: "https://brasil.un.org/pt-br/sdgs/15",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-15.svg",
  },
  {
    name: UNDevelopmentGoals["Paz, Justiça e Instituições Eficazes"],
    url: "https://brasil.un.org/pt-br/sdgs/16",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-16.svg",
  },
  {
    name: UNDevelopmentGoals["Parcerias e Meios de Implementação"],
    url: "https://brasil.un.org/pt-br/sdgs/17",
    imageUrl:
      "https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-17.svg",
  },
];

export default goals;
